import { connect } from 'react-redux'
import React, { PureComponent } from 'react'
import Preview from '../../views/preview/Preview'
import previewActions from '../../redux/actions/previewActions'
import withTransition from '../../hoc/Transition'
import viewSelector from '../../redux/selectors/preview/viewSelector'
import { ISize } from '../../helpers/data/size'
import { bindActionCreators, AnyAction, Dispatch } from 'redux'
import { ISkin as IQuestionSkin } from '../../views/question/Question'

interface IPreviewProps {
	activities: any[]
	initialize: () => void
	skin: IQuestionSkin
	size: ISize
}

class PreviewConnector extends PureComponent<IPreviewProps> {
	componentDidMount() {
		this.props.initialize()
	}

	render() {
		return <Preview activities={this.props.activities} skin={this.props.skin} size={this.props.size} />
	}
}

const mapStateToProps = (state: any) => {
	return viewSelector(state)
}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => {
	return bindActionCreators(
		{
			initialize: previewActions.initialize,
		},
		dispatch
	)
}

export default withTransition(connect(mapStateToProps, mapDispatchToProps)(PreviewConnector))
